// extracted by mini-css-extract-plugin
export default {"PortfolioManagersTable":"PortfolioManagersTable_PortfolioManagersTable__vgrWP"};